import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { copyTaskLink } from '../../../../redux/tasks/actions';

const CopyTaskMenuItem = ({ taskId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleItemClick = () => {
    dispatch(copyTaskLink(taskId, intl))
  };

  return (
    <div onClick={handleItemClick}>
      <FormattedMessage id="COPY_LINK" defaultMessage="Copy Link" />
    </div>
  );
};

export default CopyTaskMenuItem;
